import {
  fetchAll,
  fetchFiltered,
  fetchVehicleData,
  fetchVehiclePosition,
  fetchVerifySerial,
  fetchVerifyBoard,
  fetchSendCommand,
  fetchConfirmCommand,
  fetchCommandHistoric,
  fetchFinishedTest,
  addOsTests,
  show,
  edit,
  equipmentData,
  fetchAllSerials,
  fetchExchangeSerial,
  cancelCommand,
  saveOsLog
} from '@/api/ostests'

const state = {
  all            : [],
  isLoading      : false,
  osTestsById    : null,
  vehicleData    : {},
  vehiclePosition: {
    lng: 0,
    lat: 0
  },
  statusCommand: {
    1: { status: 'notSend', id: undefined },
    2: { status: 'notSend', id: undefined },
    3: { status: 'notSend', id: undefined },
    4: { status: 'notSend', id: undefined },
    5: { status: 'notSend', id: undefined },
    6: { status: 'notSend', id: undefined }
  },
  serialData                : {},
  isLocadados               : false,
  boardExist                : false,
  withdrawnSerialIsLocadados: false,
  finished                  : false,
  equipment                 : {},
  commandHistoric           : [],
  serials                   : [],
  commandCreated            : {}
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  cleanPartialState({ commit }) {
    commit('cleanPartialState')
  },

  cleanCommandCreated({ commit }) {
    commit('cleanCommandCreated')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const osTests = await show(id)
      commit('setOsById', osTests)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const osTests = await fetchAll()
      commit('setAll', osTests)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const osTests = await fetchFiltered(queriesParams)
        commit('setAll', osTests)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVehicleData ({ dispatch, commit }, queriesParams) {
    commit('setVehicleData', {})
    try {
      const { rows } = await fetchVehicleData(queriesParams)
      commit('setVehicleData', rows[0])
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVehiclePosition ({ dispatch, commit }, vehicle) {
    try {
      const lastPosition = await fetchVehiclePosition(vehicle)
      commit('setVehiclePosition', lastPosition)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVerifySerial ({ dispatch, commit }, { serial, service }) {
    try {
      const isLocadados = await fetchVerifySerial(serial)

      if (!isLocadados.CLI_ID) return commit('setIsLocadados', { isLocadados: 'serialNotFound', serialData: {} })

      if (isLocadados.CLI_ID === 2) {
        commit('setIsLocadados', { isLocadados: true, serialData: isLocadados })
        return true
      } else if (service === 4 || service === 6) {
        commit('setIsLocadados', { isLocadados: false, serialData: {} })
        return true
      } else {
        dispatch('notify/error', { message: 'noLocadados' }, { root: true })
        return false
      }

    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVerifyBoard ({ dispatch, commit }, board) {
    const hasBoard = await fetchVerifyBoard(board)

    return Object.keys(hasBoard).length === 0
      ? false
      : true
  },

  async fetchVerifyWithdrawnSerial ({ dispatch, commit }, serial) {
    try {
      const withdrawnSerialIsLocadados = await fetchVerifySerial(serial)

      if (!withdrawnSerialIsLocadados) {
        return commit('setWithdrawnSerialIsLocadados', 'withdrawnSerialNotFound')
      }

      return withdrawnSerialIsLocadados.cli_id !== 2
        ? commit('setWithdrawnSerialIsLocadados', true)
        : dispatch('notify/error', { message: 'withdrawnSerialIsLocadados' }, { root: true })

    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchSendCommand ({dispatch, commit }, { id_tipo_comando_veiculo, odometer, vehicleId }) {
    const data = { id_tipo_comando_veiculo, odometer, vehicleId }
    try {
      const command = await fetchSendCommand(data)

      if (command.affectedRows) {
        return commit('setStatusCommand', { typeCommand: data.id_tipo_comando_veiculo, id: command.insertId })
      }

    } catch (e) {
      return dispatch('notify/error', { message: 'errorToSendCommand' }, { root: true })
    }
  },

  async fetchConfirmCommand ({ dispatch, commit }) {
    let ids = []
    for (const key in state.statusCommand) {
      if (state.statusCommand[key].id) ids.push(state.statusCommand[key].id)
    }

    if (ids.length > 0) {
      try {
        const confirm = await fetchConfirmCommand(ids)

        for (const i of confirm.rows) {
          if (i.data_confirmacao_comando_veiculo) {
            commit('setStatusCommand2', { typeCommand: i.id_tipo_comando_veiculo, id: i.id_comando_veiculo })
          }
        }

      } catch (error) {
        return dispatch('notify/error', e, { root: true })
      }
    }

  },

  async fetchCommandHistoric({ dispatch, commit }, params) {
    try {
      const historic = await fetchCommandHistoric(params)

      commit('setCommandHistoric', historic)

    } catch (e) {
      return dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFinishedTest ({ dispatch, commit }, data) {
    const os = {
      ...data.os,
      msgFinish: data.msgFinish,
      vehicleData: data.vehicleData,
      activesToAdd: data.activesToAdd,
      activesToRemove: data.activesToRemove
    }

    commit('setLoading', true)
    try {
      await fetchFinishedTest(os)
      commit('setFinishedTest', true)
    } catch (e) {
      dispatch('notify/error', { message: e.message || 'internalError' }, { root: true })
      commit('setFinishedTest', false)
    } finally {
      commit('setLoading', false)
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addOsTests(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async equipmentData({ dispatch, commit }, serial) {
    try {
      const data = await equipmentData(serial)
      commit('setEquipmentData', data)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAllSerials ({ dispatch, commit }) {
    const serials = await fetchAllSerials()

    commit('setSerials', serials.filter(Boolean))
  },

  async fetchExchangeSerial ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await fetchExchangeSerial(data)
      return true
    } catch (error) {

    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async cancelCommand({ dispatch, commit }, data) {

    try {
      await cancelCommand(data)
      return true
    } catch (error) {
      dispatch('notify/error', error, { root: true })
      return false
    }

  },

  saveOsLog ({ dispatch, commit }, data) {
    saveOsLog(data)
  },
}

const mutations = {
  cleanState (state) {
    state.all            = []
    state.isLoading      = false
    state.osTestsById    = null,
    state.vehicleData    = {},
    state.vehiclePosition = {
      lng: 0,
      lat: 0
    },
    state.statusCommand = {
      1: { status: 'notSend', id: undefined },
      2: { status: 'notSend', id: undefined },
      3: { status: 'notSend', id: undefined },
      4: { status: 'notSend', id: undefined },
      5: { status: 'notSend', id: undefined },
      6: { status: 'notSend', id: undefined },
    },
    state.isLocadados     = false,
    state.commandHistoric = [],
    state.serials         = [],
    state.commandCreated  = {}
  },

  cleanPartialState(state) {
    state.statusCommand = {
      1: { status: 'notSend', id: undefined },
      2: { status: 'notSend', id: undefined },
      3: { status: 'notSend', id: undefined },
      4: { status: 'notSend', id: undefined },
      5: { status: 'notSend', id: undefined },
      6: { status: 'notSend', id: undefined },
    },
    state.commandHistoric = []
    state.commandCreated  = {}
  },

  cleanCommandCreated() {
    state.commandCreated = {}
  },

  setAll (state, osTests) {
    state.all = osTests
  },

  setVehicleData(state, data) {
    state.vehicleData = data
  },

  setVehiclePosition(state, vehicle){
    state.vehiclePosition = vehicle
  },

  setStatusCommand(state, data) {
    state.statusCommand[data.typeCommand] = {
      status: 'pending',
      id: data.id
    }

    state.commandCreated = { commandId: data.id }
  },

  setStatusCommand2(state, data) {
    state.statusCommand[data.typeCommand] = {
      status: 'confirmed',
      id: data.id
    }
  },

  setIsLocadados(state, { isLocadados, serialData }) {
    state.serialData = serialData
    state.isLocadados = isLocadados
  },

  setBoardExist(state, boardExist) {
    state.boardExist = boardExist
  },

  setWithdrawnSerialIsLocadados(state, withdrawnSerialIsLocadados) {
    state.withdrawnSerialIsLocadados = withdrawnSerialIsLocadados
  },

  setFinishedTest(state, finished) {
    state.finished = finished
  },

  setOsById (state, osTests) {
    state.osTestsById = {
      id: osTests.id,
      garageAccredited: typeof(osTests.garageAccredited) == 'object' ? osTests.garageAccredited.id : osTests.garageAccredited,
      technicalUsers: osTests.technicalUsers ? (typeof(osTests.technicalUsers) == 'object' ? osTests.technicalUsers.id : osTests.technicalUsers) : '',
      serial: osTests.serial,
      contract: typeof(osTests.contract) == 'object' ? osTests.contract.id_contrato : osTests.contract,
      board: osTests.board,
      brand: osTests.brand,
      model: osTests.model,
      color: osTests.color,
      year: osTests.year,
      vehicleType: osTests.vehicleType,
      odometer: osTests.odometer,
      services: typeof(osTests.services) == 'object' ? osTests.services.id : osTests.services,
      maintanceReason: osTests.maintanceReason ? (typeof(osTests.maintanceReason) == 'object' ? osTests.maintanceReason.id : osTests.maintanceReason) : '',
      withdrawnSerial: osTests.withdrawnSerial,
      obs: osTests.obs,
      activeList: osTests.activeList
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  setEquipmentData(state, equipment) {
    state.equipment = equipment[0]
  },

  setCommandHistoric(state, historic) {
    state.commandHistoric = historic
  },

  setSerials(state, serials) {
    state.serials = serials
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
